export const getDotsPadding = (isMobile: boolean, isTablet: boolean, dotsPaddingTop: number | undefined): number => {
  const getDeviceTypeBasedOnTablet = isTablet ? 'tablet' : 'desktop';
  const deviceType: string = isMobile ? 'mobile' : getDeviceTypeBasedOnTablet;
  const defaultPaddings: { [key: string]: number } = { mobile: 16, tablet: 32, desktop: 48 };
  return dotsPaddingTop ?? defaultPaddings[deviceType as keyof typeof defaultPaddings];
};
